import { Suspense, useEffect } from "react";
import { useSession } from "next-auth/react";
import { useRouter, useSearchParams } from "next/navigation";

import { AuthCard } from "@/components/auth/auth-card";

export function LoginPage() {
  const { data: session, status } = useSession();
  const router = useRouter();
  const searchParams = useSearchParams();
  const callbackUrl = searchParams.get("callbackUrl") ?? "/";

  useEffect(() => {
    if (status === "authenticated") {
      if (session?.user?.role === "ADMIN") {
        router.replace(callbackUrl.startsWith("/admin") ? callbackUrl : "/admin");
      } else if (session?.user?.role === "ADMIN1") {
        router.replace(callbackUrl.startsWith("/admin1") ? callbackUrl : "/admin1");
      } else if (session?.user?.role === "VENDOR") {
        router.replace(callbackUrl.startsWith("/vendor") ? callbackUrl : "/vendor");
      }
    }
  }, [status, session, router, callbackUrl]);

  return (
    <div className="min-h-[calc(100vh-260px)] bg-gradient-to-b from-slate-100 to-white px-5 py-12 dark:from-slate-950 dark:to-slate-900">
      <Suspense fallback={null}>
        <AuthCard mode="login" />
      </Suspense>
    </div>
  );
}

